
import styles from "./PartWorkUsed.module.scss";
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from "react";
import PartWorkItemUsed from './components/PartWorkItemUsed';
import PartWorkItemUse from './components/PartWorkItemUse';
import { getTestUserDetailData, StartTestUser, getTestUser } from "service/TestService";
import { useLocation, useNavigate } from 'react-router-dom'
import userInfo from "utils/userInfo";
import { Button, Layout } from "components";
import moment from 'moment';
import Moment from 'react-moment'
import Notification from "utils/Notifications";

const PartWorkUsed = () => {
  const { t } = useTranslation('common')

  const user = userInfo();
  const [id, setId] = useState(null);
  const [data, setData] = useState([]);
  const [usedata, setData2] = useState([]);

  const navigate = useNavigate()
  const location = useLocation()
  const [render, setRender] = useState(false)
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const StartTestOn = async (event) => {
    event.preventDefault();
    try {
      const response = await StartTestUser(id);
      setData2(response.data)
      setNotify({
        isOpen: true,
        message: "Тест успешно начат!",
        type: "success",
      });

      setRender(render)


    } catch (error) {
      setNotify({
        isOpen: true,
        message: "Ошибка при запуске, попробуйте позже!",
        type: "error",
      });
    }
  }
  const getData = async (id) => {
    try {
      let response = await getTestUserDetailData(id, data);
      let response_user_data = await getTestUser(id, data);

      setData(response.data);
      setData2(response_user_data.data)
      
    } catch (error) {
    }
  };
  useEffect(() => {
    if (location.state && location.state.usedId) {

      const usedId = location.state.usedId;

      setId(usedId)

      getData(usedId);

      setRender(false);
    } else {

      navigate("/tests");
    }


  }, [render, location.pathname, location.state]);

  const formatDate = (dateString) => {
    const date = moment(dateString, 'DD.MM.YYYY HH:mm');
    const today = moment();

    if (date.isSame(today, 'day')) {
      return date.format('Сегодня HH:mm');
    }
    else if (date.isSame(today, 'year')) {
      return date.format('DD MMMM HH:mm')
    }
    else {
      return date.format('DD MMMM YYYY HH:mm');
    }
  };

  return (
    <Layout>
      <div className={styles.test_card}>
        <div style={{ display: 'flex', alignItems: 'start', flexDirection: 'column', justifyContent: 'start', width: '100%' }}>
          <div className={styles["test-app"]}>
            <h2>{data.title}</h2>
            <Button
              className={styles.open_btn}
              onClick={() => navigate('/tests/')}
            >
              Вернуться
            </Button>
          </div>
          <div className={styles.answer_header_selections}>
            <div>
              <h4>Дата создания теста: {formatDate(data.createdAt)}</h4>
              <h4>Сегодня: <Moment format="DD MMMM YYYY" interval={1000} /> <Moment format="HH:mm:ss" interval={1000} /></h4>
              {(usedata?.status_info === "Начат") ?
                <h4>Вопросов: {data?.part_worktest?.filter(item => item.type_answer !== "infoText").length || 0}</h4> : ""}
              {(usedata?.status_info === "Завершен") ?
                <span><h4>{t('auto.usedcomponents_partworkused.k1')} </h4> <span style={{ display: 'flex', alignItems: 'end', justifyContent: "center", fontSize: '22px' }}><h1>{usedata?.points}</h1></span></span> : ""}
            </div>
            <div>
              <h4>{user.surName} {user.firstName}</h4>
              <h4>Статус: {usedata?.status_info ? usedata?.status_info : "Не начат"}</h4>
              {(usedata?.status_info === "Завершен") ?
                <>
                  <h4>Дата/Время начала: {formatDate(usedata?.createdAt)}</h4>
                  <h4>Дана/Время завершения: {formatDate(usedata?.endAt)}</h4>
                  <h4>Потрачено времени: {usedata?.time_response}</h4>
                  <h4>Пройдено вопросов: {usedata?.working_info}</h4>

                </>
                : ((usedata?.status_info === "Начат") ? <><h4>Дата/Время начала: {usedata?.createdAt}</h4></> : "")}
            </div>
          </div>
        </div>
        {(usedata?.status_info !== "Начат" && usedata?.status_info !== "Завершен") ?
          <>
            <div className={styles.answer_card_selection_header}>

              <h2>Вопросов: {data?.part_worktest?.filter(item => item.type_answer !== "infoText").length || 0}</h2>

            </div>
            <div className={styles.answer_card_selection_footer}>


              <button
                className={styles.start_btn}
                onClick={StartTestOn}
              >
                {t('tests.start_test')}
              </button>


            </div>
          </> : ''}
        {(usedata?.status_info === "Начат") &&
          <>
            {data?.part_worktest?.map((item, index) =>
              <PartWorkItemUsed
                item={item}
                item_selected={usedata?.userusetest_employee_tests
                  ?.filter(testItem => testItem.part === item.id || 0)
                  ?.map(filteredItem => filteredItem.part || "Default Value")}

                index={index}

                setRender={setRender}
              />


            )}

          </>

        }
        {(usedata?.status_info === "Завершен") &&
          <>
            {data?.part_worktest?.map((item, index) =>
              <PartWorkItemUse
                item={item}
                item_selected={usedata?.userusetest_employee_tests
                  ?.filter(testItem => testItem.part === item.id || 0)
                  ?.map(filteredItem => filteredItem.part || "Default Value")}
                item_selected_data={usedata?.userusetest_employee_tests
                  ?.filter(testItem => testItem.part === item.id)  
                }
                index={index}

                setRender={setRender}
              />


            )}
          </>
        }
      </div >
      <Notification notify={notify} setNotify={setNotify} />
    </Layout>
  );
};

export default PartWorkUsed;
